"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _treeEpics = require("../tree/epics");
const _generatePreviewEpics = require("../generatePreview/epics");
function default_1(namespace) {
    const treeEpics = _treeEpics.default(`preview-${namespace}`);
    const generatePreviewEpics = _generatePreviewEpics.default(`preview-${namespace}`);
    return {
        convert: generatePreviewEpics.convert,
        fetchTree: treeEpics.fetchTree
    };
}
exports.default = default_1;
//# sourceMappingURL=epics.js.map